import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {ConnectedRouter} from 'react-router-redux';

// Import Semantic UI before App
import 'semantic-ui-css/semantic.min.css';

import registerServiceWorker from './utils/registerServiceWorker';
import {history, store} from './store';

import App from './App';

// Provide Redux store, connect Router and render App
ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <App/>
        </ConnectedRouter>
    </Provider>,
    document.getElementById(
        'root'
    )
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js